import { List5Way as List5WayMobile } from "./indexMobile";

function Lis5WayMain({ type }: { type: string }) {
  return <List5WayMobile type={type}/>;
}

export default Lis5WayMain;
